export default (value) => {
  if (value !== null) {
    const date = new Date(value)
    return date.toLocaleDateString(['en-US'], {month: 'short', day: '2-digit', year: 'numeric'})
  }
  return ''
}
